module.exports = __webpack_public_path__ + "web/img/grade2.a603f25d.png";